var script = document.createElement('script');
script.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
script.type = 'text/javascript';
document.getElementsByTagName('head')[0].appendChild(script);
//$("img").prop("alt", "Test");

$('a[href$="https://kossonutrition.nl/"]').click(function() {
  event.preventDefault();
  window.open("http://www.kossonutrition.nl");
});
$('a[href$="https://musclemeals.nl/"]').click(function() {
  event.preventDefault();
  window.open("https://musclemeals.nl/");
});
$( ".product__media-wrapper" ).removeAttr("href");
$(".product__media-preview-image").removeAttr("alt");

$("#scrollDownSlider").click(function() {
  

    event.preventDefault();
    $('html, body').animate({
      scrollTop: $("#shopify-section-featured_collection_iGyD89").offset().top
    }, 500);

});
if(window.location.href === "https://jaimyfitt.nl/pages/vragenlijst-personal-training?contact_posted=true#contact_form"){
    //window.location.replace("https://jaimyfitt.nl/pages/bedankt-1");
};
if(window.location.href === "https://jaimyfitt.nl/cart"){
    document.title = 'Winkelwagen - Jaimy Fitt';
};
if(window.location.href === "https://jaimyfitt.nl/collections/losse-schemas"){
    document.title = "Losse Schema's - Jaimy Fitt";
};
if(window.location.href === "https://jaimyfitt.nl/"){
    document.title = 'Home - Jaimy Fitt';
};

$('a[href$="disable-click"]').click(function() {
  event.preventDefault();
});


$('a[href$="/collections/all"]').click(function() {
  window.location.replace("https://jaimyfitt.nl/");
  event.preventDefault();
});


if(window.location.href === "https://jaimyfitt.nl/pages/combideals"){
    $( ".section-header__title" ).hide();
};

$('#vragenlijst').click(function() {
  window.location.replace("https://jaimyfitt.nl/pages/vragenlijst-personal-training");
  event.preventDefault();
});

if(window.location.href === "https://jaimyfitt.nl/products/personal-training"){
  sessionStorage.setItem("pakket","Personal training");
  $( "<a href='https://jaimyfitt.nl/pages/vragenlijst-personal-training' class='btn btn--to-secondary btn--full product__add-to-cart-button shopify-payment-btn btn--secondary' aria-describedby='a11y-external-message'>PERSONAL TRAINING AANVRAGEN</a>" ).insertBefore( ".product__add-to-cart-button" );
  $("button[name='add']").hide();
};
if(window.location.href === "https://jaimyfitt.nl/pages/vragenlijst-personal-training"){
  $("#sheetdb-form").css("display", "block");
};


if(window.location.href === "https://jaimyfitt.nl/products/duo-training"){
  sessionStorage.setItem("pakket","Duo training");
  $( "<a href='https://jaimyfitt.nl/pages/vragenlijst-personal-training' class='btn btn--to-secondary btn--full product__add-to-cart-button shopify-payment-btn btn--secondary' aria-describedby='a11y-external-message'>DUO TRAINING AANVRAGEN</a>" ).insertBefore( ".product__add-to-cart-button" );
  $("button[name='add']").hide();
};

if(window.location.href === "https://jaimyfitt.nl/pages/vragenlijst-personal-training"){
	var pakket = sessionStorage.getItem("pakket");
  	$("input[name='contact[pakket]']").val(pakket);
  
};
if(window.location.href === "https://jaimyfitt.nl/pages/vragenlijst-personal-training?contact_posted=true"){
  window.location.replace("https://jaimyfitt.nl/pages/bedankt-1");
};

$('#submitContactFormAction').click(function() {
   window.location.replace("https://jaimyfitt.nl/pages/bedankt-1");
});

if(window.location.href === "https://jaimyfitt.nl/57453019330/policies/privacy-policy.html?locale=nl"){
	window.location.replace("https://jaimyfitt.nl/57453019330/policies/terms-of-service.html?locale=nl");
};
if(window.location.href === "https://jaimyfitt.nl/57453019330/policies/refund-policy.html?locale=nl"){
	window.location.replace("https://jaimyfitt.nl/57453019330/policies/terms-of-service.html?locale=nl");
};




$('.cart-item__qty-input').click(function() {
  //location.reload();
});

if(window.location.href === "https://jaimyfitt.nl/policies/terms-of-service"){
	$( "button" ).css("text-align","justify");
};


$('a[href$="/products/blauw"]').click(function() {
  window.location.replace("https://jaimyfitt.nl/products/shirt");
  event.preventDefault();
});
$('a[href$="/products/zwart"]').click(function() {
  window.location.replace("https://jaimyfitt.nl/products/shirt");
  event.preventDefault();
});
$('a[href$="/products/shirt-rood"]').click(function() {
  window.location.replace("https://jaimyfitt.nl/products/shirt");
  event.preventDefault();
});
$('a[href$="/products/wit"]').click(function() {
  window.location.replace("https://jaimyfitt.nl/products/shirt");
  event.preventDefault();
});
$('a[href$="/products/geel"]').click(function() {
  window.location.replace("https://jaimyfitt.nl/products/shirt");
  event.preventDefault();
});
$('a[href$="/products/oranje"]').click(function() {
  window.location.replace("https://jaimyfitt.nl/products/shirt");
  event.preventDefault();
});


$.urlParam = function(name){
    var results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
    return results[1] || 0;
}
if ($.urlParam('type') == 'redirectPage') {  // variable_name would be the name of your variable within your url following the ? symbol
  
  //alert($.urlParam('redirectUrl')+ "&email=" +$.urlParam('email')+"%0D%0A");
  var newUrl = $.urlParam('redirectUrl')+ "&email=" +$.urlParam('email')+"%0D%0A";
  window.location.replace(newUrl);
}
if ($.urlParam('type') == 'click') {  // variable_name would be the name of your variable within your url following the ? symbol
	$('select option[value=S]').click();
}
if ($.urlParam('type') == 'Combideal') {  // variable_name would be the name of your variable within your url following the ? symbol
	//alert("https://jaimyfitt.nl/pages/vragenlijst-combideal?order=" + $.urlParam('order') + "&email=" + $.urlParam('email') );
  	//window.location.replace("https://jaimyfitt.nl/pages/vragenlijst-combideal");
	sessionStorage.setItem("order", $.urlParam('order'));
  	sessionStorage.setItem("email", $.urlParam('email'));
  	sessionStorage.setItem("secret_key","gPjwpseTzoLPax1i4Cxg");
  	var order = sessionStorage.getItem("order");
  	var email = sessionStorage.getItem("email");
  	var secret_key = sessionStorage.getItem("secret_key");
  
  //alert(order + " " + email + " " + secret_key);
  window.location.replace("https://jaimyfitt.nl/pages/vragenlijst-combideal");
}
if ($.urlParam('type') == 'Trainingsschema') {  // variable_name would be the name of your variable within your url following the ? symbol
	//alert("https://jaimyfitt.nl/pages/vragenlijst-combideal?order=" + $.urlParam('order') + "&email=" + $.urlParam('email') );
  	//window.location.replace("https://jaimyfitt.nl/pages/vragenlijst-combideal");
	sessionStorage.setItem("order", $.urlParam('order'));
  	sessionStorage.setItem("email", $.urlParam('email'));
  	sessionStorage.setItem("secret_key","gPjwpseTzoLPax1i4Cxg");
  	var order = sessionStorage.getItem("order");
  	var email = sessionStorage.getItem("email");
  	var secret_key = sessionStorage.getItem("secret_key");
  
  //alert(order + " " + email + " " + secret_key);
  window.location.replace("https://jaimyfitt.nl/pages/vragenlijst-trainingsschema");
}

if ($.urlParam('type') == 'Voedingsschema') {  // variable_name would be the name of your variable within your url following the ? symbol
	//alert("https://jaimyfitt.nl/pages/vragenlijst-combideal?order=" + $.urlParam('order') + "&email=" + $.urlParam('email') );
  	//window.location.replace("https://jaimyfitt.nl/pages/vragenlijst-combideal");
	sessionStorage.setItem("order", $.urlParam('order'));
  	sessionStorage.setItem("email", $.urlParam('email'));
  	sessionStorage.setItem("secret_key","gPjwpseTzoLPax1i4Cxg");
  	var order = sessionStorage.getItem("order");
  	var email = sessionStorage.getItem("email");
  	var secret_key = sessionStorage.getItem("secret_key");
  
  //alert(order + " " + email + " " + secret_key);
  window.location.replace("https://jaimyfitt.nl/pages/vragenlijst-voedingsschema");
}

var urlParams = new URLSearchParams(window.location.search); //get all parameters
var form_type = urlParams.get('form_type'); //extract the foo parameter - this will return NULL if foo isn't a parameter

if(foo) { //check if foo parameter is set to anything
  if(foo == 'customer') { //check if foo parameter is 'bar'
      $('.form-success').show();
  }
}




